(() => {
  if (window.nlGuaranteeDialogBound) return;
  window.nlGuaranteeDialogBound = true;
  let dialog;
  let opener;
  let openerHref;
  let openerCartKey;
  let handledEscape = false;
  document.addEventListener('keydown', event => {
    if (!dialog?.open) return;
    if (event.key === 'Escape') handledEscape = true;
    if (event.key === 'Escape' || event.key === 'Tab') event.stopPropagation();
    if (event.key === 'Tab') {
      const focusable = [...dialog.querySelectorAll('button:not([disabled]), a[href]')].filter(node => node.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last || !dialog.contains(document.activeElement)) {
        event.preventDefault();
        first?.focus();
      }
    }
  }, true);
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape' && handledEscape) {
      event.stopPropagation();
      handledEscape = false;
    }
  }, true);
  function createDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'nl-guarantee-dialog';
    dialog.setAttribute('aria-labelledby', 'nl-guarantee-dialog-title');
    dialog.innerHTML = '<div class="nl-guarantee-dialog__header"><h2 id="nl-guarantee-dialog-title" class="nl-guarantee-dialog__title"></h2><button type="button" class="nl-guarantee-dialog__close" aria-label="Sluiten"><span aria-hidden="true">&#215;</span></button></div><div class="nl-guarantee-dialog__body"><div class="nl-guarantee-dialog__image-container"><img class="nl-guarantee-dialog__image" alt=""></div><div class="nl-guarantee-dialog__links"><button type="button" data-zoom aria-pressed="false"><span aria-hidden="true">+</span> Vergroten</button><a target="_blank" rel="noopener" data-original>Afbeelding op ware grootte</a><a target="_blank" rel="noopener" data-terms></a></div></div>';
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.querySelector('[data-zoom]').addEventListener('click', event => {
      const button = event.currentTarget;
      const zoomed = dialog.querySelector('.nl-guarantee-dialog__image-container').classList.toggle('is-zoomed');
      button.setAttribute('aria-pressed', String(zoomed));
      button.innerHTML = zoomed ? '<span aria-hidden="true">&#8722;</span> Verkleinen' : '<span aria-hidden="true">+</span> Vergroten';
    });
    dialog.addEventListener('click', event => {
      event.stopPropagation();
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      const replacement = [...document.querySelectorAll('[data-nl-guarantee-dialog]')].find(link => link.href === openerHref && link.closest('[data-key]')?.dataset.key === openerCartKey);
      const target = opener?.isConnected ? opener : replacement || document.querySelector('#CartPageForm .cart__checkout') || document.querySelector('#CartDrawer.drawer--is-open .cart__checkout') || document.querySelector('main');
      if (target) {
        if (target.tagName === 'MAIN') target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-nl-guarantee-dialog]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0 || !window.HTMLDialogElement) return;
    if (!dialog) createDialog();
    if (typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    opener = link;
    openerHref = link.href;
    openerCartKey = link.closest('[data-key]')?.dataset.key;
    const title = link.dataset.title;
    dialog.querySelector('h2').textContent = title;
    const img = dialog.querySelector('img');
    img.alt = link.dataset.fullAlt || title;
    const isNotice = link.closest('.nl-guarantee-notice') !== null;
    const isAcCore = link.closest('[data-nl-guarantee-model]')?.dataset.nlGuaranteeModel === 'ac-core';
    img.width = isNotice ? 1273 : isAcCore ? 1000 : 808;
    img.height = isNotice ? 1800 : isAcCore ? 1053 : 850;
    img.src = link.href;
    dialog.querySelector('.nl-guarantee-dialog__image-container').classList.remove('is-zoomed');
    dialog.querySelector('[data-zoom]').setAttribute('aria-pressed', 'false');
    dialog.querySelector('[data-zoom]').innerHTML = '<span aria-hidden="true">+</span> Vergroten';
    const original = dialog.querySelector('[data-original]');
    original.href = link.href;
    const terms = dialog.querySelector('[data-terms]');
    terms.href = link.dataset.terms;
    terms.textContent = link.dataset.termsLabel;
    dialog.showModal();
    dialog.scrollTop = 0;
    dialog.querySelector('button').focus({ preventScroll: true });
  });
})();

(() => {
  'use strict';
  if (window.garanHoverBound) return;
  window.garanHoverBound = true;
  const selector = '.nl-guarantee__label[data-nl-guarantee-dialog], .wv-guarantee__label[data-wv-guarantee-open], a.drbo-guarantee__label[data-guarantee-open], [data-garan-hover-src]';
  const hoverMedia = matchMedia('(any-hover: hover) and (any-pointer: fine)');
  const locale = document.documentElement.lang.toLowerCase();
  const closeLabel = locale.startsWith('nl') ? 'Sluiten' : locale.startsWith('de') ? 'Schlie\u00dfen' : locale.startsWith('es') ? 'Cerrar' : 'Close';
  const panel = document.createElement('div');
  panel.id = 'garan-hover-panel';
  panel.className = 'garan-hover-panel';
  panel.hidden = true;
  panel.setAttribute('role', 'region');
  panel.setAttribute('aria-label', 'GARAN');
  const bar = document.createElement('div');
  bar.className = 'garan-hover-panel__bar';
  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.className = 'garan-hover-panel__close';
  closeButton.setAttribute('aria-label', closeLabel);
  closeButton.textContent = '\u00d7';
  const image = document.createElement('img');
  image.className = 'garan-hover-panel__image';
  bar.append(closeButton);
  panel.append(bar, image);
  const bridge = document.createElement('div');
  bridge.className = 'garan-hover-bridge';
  bridge.hidden = true;
  bridge.setAttribute('aria-hidden', 'true');
  document.body.append(bridge, panel);
  let active = null;
  let dismissed = null;
  let timer;
  let frame;
  let lastTouch = 0;
  let oldControls;
  let returningFocus = null;
  let modalOpener = null;
  let handledEscape = false;
  const source = link => link.dataset.garanHoverSrc || link.href;
  const title = link => link.dataset.fullAlt || link.dataset.guaranteeTitle || link.dataset.title || link.getAttribute('aria-label') || 'GARAN';
  const over = node => node?.isConnected && node.matches(':hover');
  const focused = node => node?.contains(document.activeElement);

  function hide(suppress = false) {
    clearTimeout(timer);
    const restoreFocus = focused(panel);
    const previous = active;
    if (suppress) dismissed = active;
    if (active) {
      if (oldControls === null) active.removeAttribute('aria-controls');
      else active.setAttribute('aria-controls', oldControls);
    }
    panel.hidden = true;
    bridge.hidden = true;
    active = null;
    if (restoreFocus) {
      const target = previous?.isConnected && previous.getClientRects().length ? previous : document.querySelector('main');
      if (target) {
        returningFocus = previous;
        if (target.tagName === 'MAIN') target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
      }
    }
  }
  function position() {
    if (!active?.isConnected || !active.getClientRects().length) return hide();
    const box = active.getBoundingClientRect();
    if (box.bottom < 0 || box.top > innerHeight) {
      bridge.hidden = true;
      if (focused(panel) || focused(active)) return;
      return hide();
    }
    const ratio = image.naturalWidth && image.naturalHeight ? image.naturalWidth / image.naturalHeight : 0.95;
    const width = Math.max(180, Math.min(540, innerWidth - 24, (innerHeight - 84) * ratio + 22));
    panel.style.width = width + 'px';
    const height = panel.getBoundingClientRect().height;
    let left = box.right + 10;
    if (left + width > innerWidth - 12) left = box.left - width - 10;
    if (left < 12) left = Math.min(innerWidth - width - 12, Math.max(12, box.left));
    let top = box.top;
    if (left < box.right && left + width > box.left) {
      top = box.bottom + 10;
      if (top + height > innerHeight - 12) top = box.top - height - 10;
    }
    panel.style.left = Math.max(12, left) + 'px';
    panel.style.top = Math.max(12, Math.min(top, innerHeight - height - 12)) + 'px';
    const p = panel.getBoundingClientRect();
    let b;
    if (p.right <= box.left || p.left >= box.right) {
      b = {left: Math.min(p.right, box.right) - 1, top: Math.max(p.top, box.top),
        width: Math.max(p.left - box.right, box.left - p.right) + 2,
        height: Math.max(0, Math.min(p.bottom, box.bottom) - Math.max(p.top, box.top))};
    } else {
      b = {left: Math.max(p.left, box.left), top: Math.min(p.bottom, box.bottom) - 1,
        width: Math.max(0, Math.min(p.right, box.right) - Math.max(p.left, box.left)),
        height: Math.max(p.top - box.bottom, box.top - p.bottom, 0) + 2};
    }
    Object.assign(bridge.style, {left:b.left+'px',top:b.top+'px',width:b.width+'px',height:b.height+'px'});
    bridge.hidden = b.width <= 0 || b.height <= 0;
  }
  function show(link) {
    clearTimeout(timer);
    if (dismissed === link || modalOpener === link || !link.getClientRects().length || link.closest('[hidden]') || document.querySelector('dialog[open]')) return;
    if (active === link && !panel.hidden) return;
    hide();
    active = link;
    oldControls = link.getAttribute('aria-controls');
    link.setAttribute('aria-controls', [oldControls, panel.id].filter(Boolean).join(' '));
    image.alt = title(link);
    image.src = source(link);
    panel.setAttribute('aria-label', title(link));
    panel.hidden = false;
    position();
  }
  function scheduleHide() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (!over(active) && !over(panel) && !over(bridge) && !focused(active) && !focused(panel)) hide();
    }, 220);
  }
  image.addEventListener('load', () => { if (active) position(); });
  image.addEventListener('error', () => hide());
  document.addEventListener('pointerover', event => {
    if (!hoverMedia.matches || event.pointerType !== 'mouse' || Date.now() - lastTouch < 800) return;
    const link = event.target.closest?.(selector);
    if (link && !link.contains(event.relatedTarget)) show(link);
  });
  document.addEventListener('pointerout', event => {
    const link = event.target.closest?.(selector);
    if (link && !link.contains(event.relatedTarget)) {
      if (dismissed === link) dismissed = null;
      scheduleHide();
    }
  });
  document.addEventListener('pointerdown', event => {
    if (event.pointerType === 'touch') { lastTouch = Date.now(); hide(); }
  }, true);
  document.addEventListener('pointermove', event => {
    if (dismissed && !dismissed.contains(event.target)) dismissed = null;
    if (modalOpener && !modalOpener.contains(event.target) && !document.querySelector('dialog[open]')) {
      modalOpener = null;
      returningFocus = null;
    }
  }, {passive: true});
  document.addEventListener('focusin', event => {
    const link = event.target.closest?.(selector);
    if (link && Date.now() - lastTouch > 800) {
      if (returningFocus === link) { returningFocus = null; dismissed = link; return; }
      if (dismissed === link) dismissed = null;
      show(link);
    }
  });
  document.addEventListener('focusout', event => {
    const link = event.target.closest?.(selector);
    if (link && dismissed === link && !over(link)) dismissed = null;
    scheduleHide();
  });
  panel.addEventListener('pointerenter', () => clearTimeout(timer));
  panel.addEventListener('pointerleave', scheduleHide);
  bridge.addEventListener('pointerenter', () => clearTimeout(timer));
  bridge.addEventListener('pointerleave', scheduleHide);
  closeButton.addEventListener('click', () => {
    const link = active;
    returningFocus = link;
    hide(true);
    link?.focus({preventScroll: true});
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Tab' && !document.querySelector('dialog[open]')) {
      modalOpener = null;
      returningFocus = null;
      dismissed = null;
    }
    if (event.key !== 'Escape' || panel.hidden) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    handledEscape = true;
    hide(true);
  }, true);
  document.addEventListener('keyup', event => {
    if (event.key === 'Escape' && handledEscape) {
      event.stopImmediatePropagation();
      handledEscape = false;
    }
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest?.(selector);
    if (link) { returningFocus = link; modalOpener = link; hide(true); }
    else if (!panel.contains(event.target)) hide();
  }, true);
  const reposition = () => {
    cancelAnimationFrame(frame);
    if (active) frame = requestAnimationFrame(position);
  };
  window.addEventListener('resize', reposition);
  document.addEventListener('scroll', reposition, {passive: true, capture: true});
  const seen = new WeakSet();
  const images = new Map();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const url = source(entry.target);
      if (url && !images.has(url)) { const preload = new Image(); preload.src = url; images.set(url, preload); }
      observer.unobserve(entry.target);
    }
  }, {rootMargin: '240px'}) : null;
  function scan() {
    if (active && (!active.isConnected || !active.getClientRects().length)) hide();
    if (active && (image.src !== source(active) || image.alt !== title(active))) {
      image.alt = title(active);
      image.src = source(active);
      panel.setAttribute('aria-label', title(active));
      position();
    }
    document.querySelectorAll(selector).forEach(link => {
      if (seen.has(link)) return;
      seen.add(link);
      observer?.observe(link);
    });
  }
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; scan(); });
  }).observe(document.body, {childList: true, subtree: true, attributes: true,
    attributeFilter: ['hidden', 'href', 'data-full-alt', 'data-guarantee-title', 'data-title', 'data-garan-hover-src']});
  hoverMedia.addEventListener('change', () => { if (!hoverMedia.matches) hide(); });
  scan();
})();
